<template>
    <div v-loading="form.busy">
        <div class="form-row">
            <div class="form-group col-xl-8 mb-1">
                <input placeholder="Имя" type="text" class="form-control" id="name" v-model="name" :class="{ 'is-invalid': form.errors.has('name') }"><has-error :form="form" field="name"/>
            </div>
            <div class="form-group col-xl-4 mb-1">
                <Select2 v-model="platform_id" :options="platform_select" :id="'cal_actual_owner_form_platform_id'" :settings="{width: '100%'}"/>
                <has-error :form="form" field="platform_id" class="d-block"/>
            </div>
        </div>
        <div class="form-row mt-1">
            <div class="form-group col-12">
                <button v-if="mode === 'create'" class="btn btn-primary" @click="create">Создать</button>
                <button v-if="mode === 'edit'" class="btn btn-primary" @click="update">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import Form from 'vform';
export default {
    name: "CarActualOwnerForm",
    props: {
        mode: {
            type: String,
            required: true,
            validator: function (value) {
                return ['create', 'edit'].indexOf(value) !== -1
            }
        },
        obj: {
            type: Object,
            required: false,
            default: null,
        }
    },
    data: () => ({
        name: null,
        platform_id: null,
        form: new Form({})
    }),
    computed: {
        platform_select() {
            let options = [];
            let user = this.$store.getters['auth/user'];
            if (user && user.allowed_platforms) {
                user.allowed_platforms.forEach(function (item) {
                    options.push({id: item.id, text: item.name})
                })
            }
            return options;
        },
    },
    mounted() {
        if (this.mode === 'edit' && this.obj) {
            this.name = this.obj.name;
            this.platform_id = this.obj.platform_id;
        }
    },
    methods: {
        validate() {
            this.form = new Form({
                name: this.name,
                platform_id: this.platform_id,
            })
            return true;
        },
        create() {
            let self = this;
            this.validate();
            this.form.post('/api/car_actual_owners')
                .then(response => {
                    self.$emit('created', response.data);
                })
        },
        update() {
            let self = this;
            this.validate();
            this.form.put('/api/car_actual_owners/' + this.obj.id)
                .then(response => {
                    self.$emit('updated', response.data);
                })
        },

    }
}
</script>

<style scoped>

</style>
